export default "__VITE_ASSET__BKZWTX2m__"